<template>
    <div class="imgRowWrapper message-wrapper">
        <div v-for="picture in message.pictures" :style="[{float:imgSide},$kmsTheme ? $kmsTheme.styles.imgWrapperWithText : null]" class="imgWrapper">
            <img :style="!$kmsTheme ? null : $kmsTheme.styles.imgWithText" class="rowImg" v-bind:class="[wideImage ? 'wideImage' : 'tallImage']" :src="$http.defaults.baseURL + 'digitalNoticeBoard/picture?picture_id=' + picture.noticePictureId + '&type=' + picture.type" />
        </div>
        <div class="imgTextWrapper" :style="[{float: textFloat}]">
            <p :style="[{fontSize : fontSize + 'px'}, {color : messageColour}, $kmsTheme ? $kmsTheme.styles.messageText : null]" :id="message.noticeMessageId" class="resize">
                <template v-if="message.messageTitle">
                    <span :style="[{color:message.messageTitleColour}, message.messageTitleFont ? {'font-family':message.messageTitleFont} : null]">{{message.messageTitle}}</span>
                    <br />
                </template>
                <span :style="[message.messageFont ? {'font-family':message.messageFont} : null]">
                    {{message.message}}
                </span>
            </p>
        </div>

    </div>
</template>

<script>
    import Vue from 'vue';
    import messageMixin from './../../mixins/text-message'

    export default {
        mixins: [messageMixin],
        props: {
            imgSide: {}
        },
        computed: {
            textFloat: function () {
                if (this.imgSide == "right")
                    return "left";

                return "right";
            }
        },
        created() {
            this.parentClass = ".imgTextWrapper";
        }
    }



</script>
<style>
    .imgWrapper {
        height: 100%;
        width: 45%;
        float: left;
        text-align: center;
        margin-top: 0px;
    }

    .imgTextWrapper {
        width: 50%;
        height: 100%;
        float: right;
        margin-bottom: 0px;
    }

    @media(orientation: portrait) {

        .imgTextWrapper {
            width: 60%;
        }

        .imgWrapper {
            width: 35%;
        }
    }
</style>
